import React from "react";
import PropTypes from "prop-types";
import { LoaderCircle } from "lucide-react";

import { BUTTON_SIZES, BUTTON_VARIANTS } from "./Button";

const IconButton = ({
  "aria-label": ariaLabel,
  className = "",
  disabled = false,
  icon: Icon,
  loading = false,
  size = "default",
  title,
  type = "button",
  variant = "outline",
  ...buttonProps
}) => {
  const classes = [
    "wsm-icon-button",
    `wsm-icon-button--${variant}`,
    size !== "default" && `wsm-icon-button--${size}`,
    className,
  ].filter(Boolean);
  const DisplayIcon = loading ? LoaderCircle : Icon;

  return (
    <button
      {...buttonProps}
      aria-busy={loading || undefined}
      aria-label={ariaLabel}
      className={classes.join(" ")}
      disabled={disabled || loading}
      title={title ?? ariaLabel}
      type={type}
    >
      <DisplayIcon
        aria-hidden="true"
        className={[
          "wsm-icon-button__icon",
          loading && "wsm-icon-button__spinner",
        ].filter(Boolean).join(" ")}
      />
    </button>
  );
};

IconButton.propTypes = {
  "aria-label": PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.elementType.isRequired,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(BUTTON_SIZES),
  title: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
};

export default IconButton;
